export enum LogType {
  Default = 'default',
  Success = 'success',
  Rainbow = 'rainbow',
  Accent = 'accent',
  Secondary = 'secondary',
  Info = 'info',
  Error = 'error',
}
